import * as Types from '@/types';

import { gql } from '@apollo/client';
export const SalesPortalDetailHeaderAddressFieldsFragmentDoc = gql`
  fragment SalesPortalDetailHeaderAddressFields on addresses {
    address
    city
    latitude
    longitude
    region
    uuid
  }
`;
export const SalesPortalDetailHeaderChatFieldsFragmentDoc = gql`
  fragment SalesPortalDetailHeaderChatFields on chats {
    restaurant_account_id
    uuid
  }
`;
